import useFetch from '../hooks/useFetch';
import { PointOfSale } from '../model/pos';
import { List } from '../utils/data';

const ep = '/pos';

export function useFetchPointOfSales() {
  return useFetch<List<PointOfSale>>(ep);
}